import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { filter, takeWhile } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Table } from '../../shared/efaact-primeng.module';
@Component({
    selector: 'ef-reconciliation-export',
    templateUrl: './reconciliation-export.component.html',
    styleUrls: ['./reconciliation-export.component.scss'],
    standalone: false
})
export class ReconciliationExportComponent implements OnInit, OnDestroy, AfterViewInit {
    private itemsSubject = new ReplaySubject<any[]>();
    private _items: any[];
    @Input() public set items(value: any[]) {
        this._items = value;
        this.itemsSubject.next(value);
        this.log.verbose({
            type: 'ReconciliationExportComponent:items:set',
            value
        });
    }
    public get items(): any[] {
        return this._items;
    }
    private fileFormatsSubject = new ReplaySubject<
        fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[]
    >();
    private _fileFormats: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[];
    @Input() public set fileFormats(
        value: fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[]
    ) {
        this._fileFormats = value;
        this.fileFormatsSubject.next(value);
        this.log.verbose({
            type: 'ReconciliationExportComponent:fileFormats:set',
            value
        });
    }
    public get fileFormats(): fromDataServices.Reconciliation.Fields.ReconciliationFieldModel[] {
        return this._fileFormats;
    }
    @Input() download: ReplaySubject<any>;
    @ViewChild('dataTable', { static: true }) table: Table;

    dropdownItemHeight = environment.dropdownItemHeight;
    moment: any;
    filter: any;
    cols: {
        field: string;
        header: string;
        // include: boolean;
        // seq: number;
    }[] = [];
    private active = true;
    @ViewChild('dataTable', {static: true}) dataTable: Table;
    constructor(private log: LoggingService) {
        this.moment = moment;
    }

    ngOnInit(): void {}
    ngAfterViewInit(): void  {
        this.setupSubscriptions();
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    setupSubscriptions() {
        combineLatest([this.itemsSubject, this.fileFormatsSubject])
            .pipe(
                takeWhile(() => this.active),
                filter(([items, fields]) => !!items && items.length > 0)
            )
            .subscribe(([items, fields]) => {
                this.log.verbose({
                    type: 'ReconciliationExportComponent:itemsSubject,fileFormatsSubject',
                    items,
                    fields
                });
                const dCols = this.getDynamicColumns(items[0]);
                this.log.verbose({
                    type: 'ReconciliationExportComponent:itemsSubject,fileFormatsSubject',
                    dCols
                });
                this.cols = [
                    ...fields.filter(x => dCols.findIndex(y => x.PropertyName === y) >= 0)
                    .map(x => ({
                        field: x.PropertyName,
                        header: x.PropertyName
                    }))
                ];
                this.log.verbose({
                    type: 'ReconciliationExportComponent:itemsSubject,fileFormatsSubject',
                    cols: this.cols
                });
            });

        this.download.pipe(takeWhile(() => this.active)).subscribe(() => {
            this.table.exportCSV();
        });
    }

    private getDynamicColumns(item: any): string[] {
        if (!item) {
            return [];
        }
        const keys = Object.keys(item);
        return (
            keys
                // .filter(x => Array.isArray(item[x]))
                // .filter(x => Object.keys(item[x]).length > 1)
                // .filter(x => x !== 'Status')
                // .filter(x => x !== 'AutoCalculateAmount')
                // .filter(x => x !== 'Row_Version')
                // .filter(x => x !== 'updates')
                .filter(x => x !== 'id')
                .filter(x => item[x] !== undefined)
            // .filter(x => !(item[x] instanceof Date))
            // .filter(x => typeof item[x] === 'object')
        );
    }
}
